import { defineComponent as _defineComponent } from 'vue'
import MilwaukeePackoutBuilderService from 'JS/milwaukee/services/MilwaukeePackoutBuilderService';
import PackoutMessageModal from './PackoutMessageModal.vue';
import Spinner from 'JS/components/Spinner.vue';
import { AddToCartResult } from 'JS/services/ProductService';
import { onMounted, ref } from 'vue';
import { useEventListener } from 'JS/composables/event-listener';


export default /*#__PURE__*/_defineComponent({
  __name: 'MilwaukeePackoutBuilderApp',
  props: {
    wallPlateAvailable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	wallPlateAvailable: boolean;
}

const milwaukeePackoutBuilderService = new MilwaukeePackoutBuilderService();
const isLoading = ref<boolean>(false);



const showWallPlateUnavailableMessage = ref<boolean>();

onMounted(() => {
	showWallPlateUnavailableMessage.value = !props.wallPlateAvailable;
});

useEventListener(window, 'message', async event => {
	// confirm this is a PACKOUT builder message
	if (event.origin !== 'https://www.milwaukeetool.com') return;

	// get skus and quantities selected
	
	const packoutItems = event.data;
	if (!packoutItems || !Object.keys(packoutItems)?.length) {
		return;
	}

	for (const key in packoutItems) {
		if (!key.match(/^[-0-9]+$/)) return;
		const valueAsInt = parseInt(packoutItems[key]);
		if (Number.isNaN(valueAsInt) || valueAsInt <= 0) return;
	}

	isLoading.value = true;
	const response = await milwaukeePackoutBuilderService.addToCart(packoutItems);

	if (response.result == AddToCartResult.CannotAdd && response.invalidRequest) {
		isLoading.value = false;
		return;
	}

	let totalSuccess = false;
	if (response.result == AddToCartResult.Success
	 && response.addedProducts.length == Object.keys(packoutItems).length) { //Success
		totalSuccess = true;
	} 

	let redirect = '/cart/';
	if (!totalSuccess) {
		redirect += '?ader=true';
	}

	setTimeout(() => {
		window.location.href = redirect;
	}, 100);
});


return { __sfc: true,milwaukeePackoutBuilderService, isLoading, props, showWallPlateUnavailableMessage, PackoutMessageModal, Spinner }
}

})